import * as React from 'react';
import {
  StyledAccordion,
  StyledAccordionSummary,
  StyledAccordionDetails,
  AccordionContainer,
} from './styles';
import { Typography } from '@mui/material';
import { colors } from 'theme/colors';
import Icon from 'components/atoms/Icon/Icon';
import { EIconTypes } from 'constants/Icons';

export interface AccordionItem {
  key: string;
  title: string;
  description: string;
}

export interface CustomizedAccordionsProps {
  items: AccordionItem[];
  maxVisibleItems?: number;
  defaultExpandedIndex?: number;
}

export const CustomizedAccordions: React.FC<CustomizedAccordionsProps> = ({
  items,
  maxVisibleItems,
  defaultExpandedIndex = 0,
}) => {
  const [expanded, setExpanded] = React.useState<number | false>(defaultExpandedIndex);

  const handleChange =
    (index: number) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? index : false);
    };

  return (
    <AccordionContainer maxVisibleItems={maxVisibleItems}>
      {items.map((item, index) => (
        <StyledAccordion
          key={item.key}
          expanded={expanded === index}
          onChange={handleChange(index)}
        >
          <StyledAccordionSummary
            expandIcon={
              <>
                <span className="icon-plus">
                  <Icon type={EIconTypes.plus} fontSize={11} color={colors.black} />
                </span>

                <span className="icon-minus">
                  <Icon type={EIconTypes.minus} fontSize={11} color={colors.black} />
                </span>
              </>
            }
            aria-controls={`panel${index}-content`}
            id={`panel${index}-header`}
          >
            <Typography variant="subtitle2" sx={{ color: colors.primary900 }}>
              {item.title}
            </Typography>
          </StyledAccordionSummary>
          <StyledAccordionDetails>
            <Typography variant="body2">{item.description}</Typography>
          </StyledAccordionDetails>
        </StyledAccordion>
      ))}
    </AccordionContainer>
  );
};
